<template>
  <div class="page flex-col">
    <SiteHeader />
    <div class="block_2 flex-col" v-if="newsDetail">
      <div class="text-wrapper_1">
        <span class="text_4">首页&gt;新闻中心</span>
        <span class="text_5">&gt;新闻动态</span>
      </div>
      <span class="text_6">{{ newsDetail.title }}</span>
      <span class="text_7">{{ formatDate(newsDetail.create_time) }}</span>
      <div class="content-container"></div>
      <div class="content" v-html="newsDetail.content"></div>
      <div class="block_4 flex-row justify-between">
        <div class="text-wrapper_2 flex-col">
          <span class="text_8">上一篇</span>
          <router-link v-if="newsDetail.prev && newsDetail.prev.id"  :to="'/news-detail?id=' + newsDetail.prev.id" class="text_9">{{ newsDetail.prev.title }}</router-link>
          <span v-else class="text_9">无</span>
        </div>
        <div class="group_1 flex-row">
          <div class="block_5 flex-col"></div>
          <div class="text-wrapper_6 flex-col justify-between">
            <span class="text_10">下一篇</span>
            <router-link v-if="newsDetail.next && newsDetail.next.id"  :to="'/news-detail?id=' + newsDetail.next.id" class="text_11">{{ newsDetail.next.title }}</router-link>
            <span v-else class="text_11">无</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="loading">加载中...</div>
    <SiteFooter variant="news-detail" />
  </div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'NewsDetailPage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      newsDetail: null,
      loading: true
    };
  },
  watch: {
    '$route.query.id'(newId, oldId) {
      if (newId !== oldId) {
        this.fetchNewsDetail();
      }
    }
  },
  methods: {
    async fetchNewsDetail() {
      this.loading = true;
      this.newsDetail = null;
      try {
        const id = this.$route.query.id || 9;
        const response = await fetch(`/api/article/detail?id=${id}&cid=3`);
        const data = await response.json();
        if (data.code === 1) {
          this.newsDetail = data.data;
          this.replaceImageDomain();
        }
      } catch (error) {
        console.error('Failed to fetch news detail:', error);
      } finally {
        this.loading = false;
      }
    },
    replaceImageDomain() {
      if (this.newsDetail) {
        if (this.newsDetail.image) {
          this.newsDetail.image = this.newsDetail.image.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
        if (this.newsDetail.content) {
          this.newsDetail.content = this.newsDetail.content.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  },
  mounted() {
    this.fetchNewsDetail();
  }
};
</script>
<style scoped lang="css" src="./assets/index.rem.css" />
<style scoped>
.content-container {
  width: 43.867rem;
  height: 1px;
  background-color: #E3E3E3;
  margin: 1rem auto;
}

.content {
  margin: 1rem auto;
  line-height: 1.8;
  max-width: 39.654rem;
  color: #666;
  font-size: .64rem;
}
.content  p{

  color: #666;
  font-size: .64rem;
}

.content p {
  margin-bottom: 1rem;
}

.loading {
  text-align: center;
  padding: 2rem;
  color: #666;
}
</style>
